export const TopBottomHalf = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.600586"
        y="0.5"
        width="18.2939"
        height="18.2939"
        rx="3.5"
        stroke="black"
      />
      <line
        x1="9.39551"
        y1="19.2939"
        x2="9.39551"
        y2="9.79539"
        stroke="black"
      />
      <line
        x1="19.3945"
        y1="10.3105"
        x2="0.100584"
        y2="10.3105"
        stroke="black"
      />
    </svg>
  );
};
